/**
 * Creates a cookie
 * @param name : string Cookie name
 * @param value : string Cookie value
 * @param days : number Cookie cooldown in days
 */
export function createCookie(name: string, value: string, days: number): void {
    let expires: string = "";
    if (days) {
        const date: Date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value}${expires}; path=/`;
}

/**
 *  Retrieve cookie value.
 * @param name - Name of the cookie where the value should be retrieved.
 */
export function getCookie(name: string): string | null {
    const cookies: string[] = document.cookie.split(";");
    for (const cookie of cookies) {
        const [cookieName, cookieValue] = cookie.trim().split("=");
        if (cookieName === name) {
            return decodeURIComponent(cookieValue);
        }
    }
    return null;
}

/**
 *  Set the cookie expiration date in the past effectively deleting it.
 * @param name - Name of the cookie that should be removed.
 */
export function deleteCookie(name: string): void {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}